import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BackMethods from "../../back_component/BackMethods";
import {
    FaFileInvoice, FaMapMarkerAlt, FaUserShield, FaImages,
    FaArrowLeft, FaCalendarAlt, FaClock, FaIdCard, FaExpandAlt,
    FaTimes, FaChevronLeft, FaChevronRight, FaAlignRight, FaUserTag,
    FaBoxOpen
} from "react-icons/fa";

export default function ViolationDetailsPage() {
    const location = useLocation();
    const navigate = useNavigate();
    const { backEnd_request } = BackMethods();

    const [report, setReport] = useState(null);
    const [loading, setLoading] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(null);

    const query = new URLSearchParams(location.search);
    const reportId = query.get("id");

    const fetchDetails = async () => {
        setLoading(true);
        try {
            const res = await backEnd_request.get(
                `/ViolationReports/by-report-number?reportNumber=${reportId}`
            );
            console.log(res.data)
            setReport(res.data?.[0] || null);
        } catch (error) { console.error(error); }
        finally { setLoading(false); }
    };

    useEffect(() => {
        if (reportId) fetchDetails();
    }, [reportId]);

    const nextImage = (e) => {
        e?.stopPropagation();
        if (currentIndex < report.photos.length - 1) setCurrentIndex(currentIndex + 1);
    };

    const prevImage = (e) => {
        e?.stopPropagation();
        if (currentIndex > 0) setCurrentIndex(currentIndex - 1);
    };

    if (loading) return (
        <div className="d-flex justify-content-center align-items-center vh-100 bg-white">
            <div className="spinner-border text-dark" style={{ width: '3rem', height: '3rem' }}></div>
        </div>
    );

    if (!report) return (
        <div className="container py-5 text-center">
            <h4 className="text-muted">بيانات الضبط غير متوفرة</h4>
            <button className="btn btn-dark mt-3 px-5 rounded-pill" onClick={() => navigate(-1)}>رجوع</button>
        </div>
    );

    return (
        <div className="bg-light min-vh-100 pb-5" dir="rtl" style={{ fontFamily: 'Cairo, sans-serif' }}>

            {/* Header */}
            <div className="header-simple shadow-sm mb-5 pt-3 pb-3 text-white">
                <div className="container">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center gap-3">
                            <div className="bg-white rounded-circle p-2 d-flex align-items-center justify-content-center" style={{ width: '45px', height: '45px' }}>
                                <FaFileInvoice className="text-dark fs-5" />
                            </div>
                            <div>
                                <h4 className="fw-bold mb-0 fs-5">
                                    ضبط رقم {report.reportNumber} — {report.violationType?.name || "ضبط عام"}
                                </h4>
                                <small className="text-white-50"> {report.reportTime?.slice(0, 5)} - {report.reportDate?.split("T")[0]} </small>
                            </div>
                        </div>
                        <button className="btn btn-outline-light rounded-pill px-4 d-flex align-items-center gap-2 btn-sm shadow-sm" onClick={() => navigate(-1)}>
                            <span>رجوع</span>
                            <FaArrowLeft />
                        </button>
                    </div>
                </div>
            </div>

            <div className="container mt-n4">
                <div className="row g-4 mb-4">
                    <div className="col-lg-8">
                        {/* بيانات المخالفة */}
                        <div className="info-card mb-4 border-0 shadow-sm">
                            <h5 className="info-title"><FaIdCard className="text-secondary ms-2" /> بيانات المخالفة</h5>
                            <div className="row g-3">
                                <div className="col-md-12">
                                    <div className="field-item important d-flex justify-content-between align-items-center bg-white border">
                                        <div>
                                            <label className="text-muted small d-block mb-1">اسم المخالف</label>
                                            <span className="fw-bold text-dark fs-5">{report.offenderName}</span>
                                        </div>
                                        <div className="text-start">
                                            <label className="text-muted small d-block mb-1 text-center">الصفة</label>
                                            <span className="badge bg-dark rounded-pill fw-normal px-4 py-2 fs-7 shadow-sm">
                                                <FaUserTag className="ms-1" /> {report.offenderRole || "غير محدد"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <InfoField label="رقم القضية" value={report.caseNumber} col="col-md-4" />
                                <InfoField label="رقم المهمة" value={report.missionNumber} col="col-md-4" />
                                <InfoField label="رقم الرخصة" value={report.licenseNumber} col="col-md-4" />
                                {/* <InfoField label="اليوم والتاريخ" value={`${report.dayName} - ${report.reportDate?.split("T")[0]}`} icon={<FaCalendarAlt />} col="col-md-6" /> */}
                                {/* <InfoField label="وقت التسجيل" value={report.reportTime?.slice(0, 5)} icon={<FaClock />} col="col-md-6" /> */}
                            </div>
                        </div>

                        {/* الحجوزات */}
                        <div className="info-card mb-4 border-0 shadow-sm border-right-warning">
                            <h5 className="info-title text-dark"><FaBoxOpen className="text-warning ms-2" /> تفاصيل المواد المحجوزة</h5>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <div className="p-3 bg-light rounded-3 border">
                                        <label className="text-muted small d-block mb-1">الكمية المحجوزة</label>
                                        <div className="fw-bold fs-5 text-dark">{report.seizedQuantity || "0"}</div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="p-3 bg-light rounded-3 border">
                                        <label className="text-muted small d-block mb-1">جهة إيداع المحجوزات</label>
                                        <div className="fw-bold text-primary">{report.depositDestination || "لا توجد جهة"}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* ملخص الواقعة */}
                        <div className="info-card mb-4 border-0 shadow-sm">
                            <h5 className="info-title text-primary"><FaAlignRight className="ms-2" /> مضمون الضبط</h5>
                            <div className="p-3 bg-light rounded-3 border-start-primary">
                                <p className="mb-0 text-dark lh-lg fs-6" style={{ whiteSpace: 'pre-line' }}>
                                    {report.violationSummary || "لا يوجد ملخص نصي مسجل."}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <div className="info-card mb-4 border-0 shadow-sm border-top-dark">
                            <h5 className="info-title"><FaMapMarkerAlt className="text-danger ms-2" /> الموقع الجغرافي</h5>
                            <div className="mb-3 p-3 bg-light rounded-3 border">
                                <label className="text-muted small d-block mb-1">المنطقة</label>
                                <div className="fw-bold"> {report.city} - {report.district}</div>
                            </div>
                            <div className="p-3 bg-dark text-white rounded-3 d-flex justify-content-between align-items-center">
                                <span className="small">المسافة:</span>
                                <span className="fw-bold">{report.distanceMeters?.toFixed(1)} م</span>
                            </div>
                        </div>

                        <div className="info-card border-0 shadow-sm">
                            <h5 className="info-title text-success"><FaUserShield className="ms-2" /> موظفو الدورية</h5>
                            <div className="d-flex flex-column gap-2">
                                {[report.inspector1Name, report.inspector2Name, report.inspector3Name].filter(Boolean).map((name, i) => (
                                    <div key={i} className="inspector-badge">
                                        <span className="idx">{i + 1}</span>
                                        <span className="name fw-bold small">{name}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* المرفقات المصورة */}
                <div className="row">
                    <div className="col-12">
                        <div className="info-card border-0 shadow-sm bg-white">
                            <h5 className="info-title"><FaImages className="text-secondary ms-2" /> المرفقات المصورة (عرض كامل بدون قص)</h5>
                            <div className="row g-4">
                                {report.photos?.length > 0 ? report.photos.map((p, index) => (
                                    <div className="col-md-6" key={p.photoUid}>
                                        <div className="photo-card-large shadow-sm" onClick={() => setCurrentIndex(index)}>
                                            <img src={p.photoUrl} alt="Violation" className="img-fluid" />
                                            <div className="photo-card-overlay">
                                                <FaExpandAlt className="fs-1 mb-2" />
                                                <span className="fw-bold">انقر لرؤية التفاصيل بملء الشاشة</span>
                                            </div>
                                            <div className="photo-card-badge">صورة المرفق {index + 1}</div>
                                        </div>
                                    </div>
                                )) : <div className="p-5 text-center text-muted w-100">لا توجد صور مرفقة</div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* نظام عرض الصور المطور */}
            {currentIndex !== null && (
                <div className="fullscreen-lightbox fade-in" onClick={() => setCurrentIndex(null)}>
                    <div className="lightbox-top-bar" onClick={(e) => e.stopPropagation()}>
                        <button className="close-fs-btn shadow-lg" onClick={() => setCurrentIndex(null)}>
                            <FaTimes />
                        </button>
                        <div className="image-counter-fs">
                            {currentIndex + 1} / {report.photos.length}
                        </div>
                    </div>

                    <div className="lightbox-main-content" onClick={(e) => e.stopPropagation()}>
                        {currentIndex > 0 && (
                            <button className="nav-fs-btn prev" onClick={prevImage}><FaChevronRight /></button>
                        )}
                        <div className="ultra-wrapper" onClick={() => setCurrentIndex(null)}>
                            <img
                                key={currentIndex}
                                src={report.photos[currentIndex].photoUrl}
                                alt="Detail view"
                                className="img-ultra animate-zoom"
                            />
                        </div>
                        {currentIndex < report.photos.length - 1 && (
                            <button className="nav-fs-btn next" onClick={nextImage}><FaChevronLeft /></button>
                        )}
                    </div>

                    <div className="lightbox-bottom-bar" onClick={(e) => e.stopPropagation()}>
                        {report.photos.map((p, i) => (
                            <div
                                key={i}
                                className={`mini-thumb-box ${i === currentIndex ? 'active' : ''}`}
                                onClick={() => setCurrentIndex(i)}
                            >
                                <img src={p.photoUrl} alt="thumb" />
                            </div>
                        ))}
                    </div>
                </div>
            )}

            <style>{`
                .header-simple { background-color: #1a1d20; border-bottom: 2px solid #343a40; }
                .info-card { background: white; border-radius: 12px; padding: 25px; }
                .info-title { font-size: 1rem; font-weight: 700; border-bottom: 1px solid #f0f0f0; padding-bottom: 15px; margin-bottom: 20px; color: #212529; }
                .border-top-dark { border-top: 4px solid #1a1d20 !important; }
                .border-right-warning { border-right: 5px solid #ffc107; }
                .border-start-primary { border-right: 5px solid #0d6efd; }
                
                .field-item { padding: 15px; border-radius: 10px; transition: 0.2s; }
                .field-item.important { background: #f8f9fa; border-right: 5px solid #1a1d20; }
                .inspector-badge { display: flex; align-items: center; gap: 10px; background: #f8f9fa; padding: 10px; border-radius: 8px; border: 1px solid #eee; }
                .inspector-badge .idx { width: 24px; height: 24px; background: #1a1d20; color: white; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 0.7rem; }

                /* تعديلات الصور لضمان عدم الاقتطاع */
                .photo-card-large { 
                    height: 480px; 
                    border-radius: 16px; 
                    overflow: hidden; 
                    position: relative; 
                    cursor: pointer; 
                    border: 2px solid #eee; 
                    background-color: #f4f4f4; /* لون خلفية لملء الفراغات */
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .photo-card-large img { 
                    max-width: 100%;
                    max-height: 100%;
                    object-fit: contain; /* يمنع اقتطاع أي جزء من الصورة */
                    transition: 0.5s; 
                }
                .photo-card-large:hover img { transform: scale(1.02); }
                .photo-card-overlay { position: absolute; inset: 0; background: rgba(0,0,0,0.4); display: flex; flex-direction: column; align-items: center; justify-content: center; color: white; opacity: 0; transition: 0.3s; }
                .photo-card-large:hover .photo-card-overlay { opacity: 1; }
                .photo-card-badge { position: absolute; top: 15px; left: 15px; background: rgba(0,0,0,0.7); color: white; border-radius: 8px; padding: 5px 12px; font-size: 0.85rem; }

                /* Full Screen Styles */
                .fullscreen-lightbox { 
                    position: fixed; 
                    inset: 0; 
                    background: rgba(0,0,0,0.96); 
                    z-index: 10000; 
                    display: flex; 
                    flex-direction: column;
                }
                .lightbox-top-bar { display: flex; justify-content: space-between; align-items: center; padding: 20px 40px; z-index: 101; }
                .close-fs-btn { background: white; border: none; width: 50px; height: 50px; border-radius: 50%; font-size: 1.5rem; display: flex; align-items: center; justify-content: center; cursor: pointer; transition: 0.3s; }
                .close-fs-btn:hover { background: #ff4d4d; color: white; transform: rotate(90deg); }
                .image-counter-fs { color: white; background: rgba(255,255,255,0.1); padding: 8px 20px; border-radius: 20px; font-weight: bold; backdrop-filter: blur(5px); }
                .lightbox-main-content { flex: 1; display: flex; align-items: center; justify-content: center; position: relative; overflow: hidden; }
                .ultra-wrapper { width: 100vw; height: 100%; display: flex; align-items: center; justify-content: center; padding: 10px; }
                .img-ultra { max-width:  200%;width:100%; max-height: 95%; object-fit: contain; box-shadow: 0 0 50px rgba(0,0,0,1); }
                .nav-fs-btn { position: absolute; top: 0; bottom: 0; width: 100px; background: transparent; border: none; color: rgba(255,255,255,0.3); font-size: 3rem; transition: 0.3s; z-index: 102; }
                .nav-fs-btn:hover { color: white; background: rgba(255,255,255,0.05); }
                .nav-fs-btn.prev { right: 0; }
                .nav-fs-btn.next { left: 0; }
                .lightbox-bottom-bar { height: 100px; display: flex; justify-content: center; align-items: center; gap: 12px; background: rgba(0,0,0,0.5); padding: 10px; }
                .mini-thumb-box { width: 70px; height: 50px; border-radius: 6px; overflow: hidden; cursor: pointer; opacity: 0.4; border: 2px solid transparent; transition: 0.3s; }
                .mini-thumb-box.active { opacity: 1; border-color: #0d6efd; transform: scale(1.1); }
                .mini-thumb-box img { width: 100%; height: 100%; object-fit: cover; }
                .animate-zoom { animation: zoomIn 0.35s ease-out; }
                @keyframes zoomIn { from { opacity:0; transform: scale(0.95); } to { opacity:1; transform: scale(1); } }
                .fade-in { animation: fadeIn 0.3s ease; }
                @keyframes fadeIn { from { opacity:0; } to { opacity:1; } }
            `}</style>
        </div>
    );
}

function InfoField({ label, value, icon, col, important }) {
    return (
        <div className={col}>
            <div className={`field-item ${important ? 'important' : ''} border bg-light`}>
                <label className="text-muted small d-block mb-1">{icon} {label}</label>
                <div className={`fw-bold text-dark fs-6`}>{value || "---"}</div>
            </div>
        </div>
    );
}